<template>
  <div class="app_footer_container">
    <footer>
      <p>
        &#169; {{full_year}} Cox Media Group Ohio
      </p>
      <p>
        | 
        <span class="footer_link"
        v-for="(item, index) in footer_links"
        :key="`footer_link_`+index"
        >
          <a 
          :href="item.link"
          target="_blank"
          >
            {{item.label}}
          </a> | 
        </span>

        <logout-button
        v-if="is_logged_in"
        custom_class="footer_link"
        ></logout-button>
        
      </p>
    </footer>
  </div>
</template>

<script>
import LogoutButton from '@/features/login/logout_button.vue';
// require('@/vendor/chartbeat_tracking.js');

export default {
  name: 'AppFooter',
  data () {
    return {
      full_year: this.get_copyright_year(),
      footer_link_suffix: '?source=bod_2018',
      footer_links: [
        {
          label: 'Contest Guidelines',
          link: 'https://www.dayton.com/marketing/dayton-com-best-2018-contest-guidelines/IZSydcw1ws3deMJ790SJrM/'
        },
        {
          label: 'Visitor Agreement',
          link: 'https://www.dayton.com/visitor_agreement/'
        },
        {
          label: 'Privacy Policy',
          link: 'https://www.dayton.com/privacy_policy/'
        },
        {
          label: 'Contact',
          link: 'https://www.dayton.com/contact-us/'
        },
        {
          label: 'Mobile Apps',
          link: 'https://projects.coxmediagroupohio.com/products/mobile-products-list/'
        }
      ]
    }
  },
  created() {
    /*let cb = document.createElement('script');
    cb.src = '@/vendor/chartbeat_tracking.js';
    document.getElementsByTagName('head')[0].appendChild(cb);*/
  },
  computed: {
    is_logged_in: function() {
      return this.$root.store.session.check_login_status();
    }
  },
  methods: {
    get_copyright_year: function() {
      let year = new Date();
      return year.getFullYear();
    }
  },
  components: {
    LogoutButton
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/styles/global_styles.scss';

footer {
  background: $dcom-purple;
  color: #FFF;
  padding: 1em;
  padding-bottom: 3em;
  margin: 0;
  margin-top: 2em;
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 1;


  .footer_link {

    a {
      color: inherit;

      &:hover {
        color: yellow;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/features/footer.vue